var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNomination(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_19014_36039)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.25 6.70833V8.75H10.5C10.0359 8.75 9.59075 8.93437 9.26256 9.26256C8.93437 9.59075 8.75 10.0359 8.75 10.5V12.25H2.625C2.39294 12.25 2.17038 12.1578 2.00628 11.9937C1.84219 11.8296 1.75 11.6071 1.75 11.375V2.625C1.75 2.39294 1.84219 2.17038 2.00628 2.00628C2.17038 1.84219 2.39294 1.75 2.625 1.75H7.875C8.10707 1.75 8.32963 1.65781 8.49372 1.49372C8.65781 1.32962 8.75 1.10706 8.75 0.875C8.75 0.642936 8.65781 0.420376 8.49372 0.256282C8.32963 0.0921872 8.10707 0 7.875 0L2.625 0C1.92881 0 1.26113 0.276562 0.768845 0.768845C0.276562 1.26113 0 1.92881 0 2.625L0 11.375C0 12.0712 0.276562 12.7389 0.768845 13.2312C1.26113 13.7234 1.92881 14 2.625 14H9.61567C10.3116 14 10.979 13.7237 11.4713 13.2318L13.2312 11.4718C13.7233 10.9797 13.9999 10.3122 14 9.61625V6.70833C14 6.47627 13.9078 6.25371 13.7437 6.08962C13.5796 5.92552 13.3571 5.83333 13.125 5.83333C12.8929 5.83333 12.6704 5.92552 12.5063 6.08962C12.3422 6.25371 12.25 6.47627 12.25 6.70833Z",
    fill: "#67686D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3806 1.04538L3.08889 8.33704C2.97948 8.44642 2.918 8.59476 2.91797 8.74946V10.4995C2.91797 10.6542 2.97943 10.8025 3.08882 10.9119C3.19822 11.0213 3.34659 11.0828 3.5013 11.0828H5.2513C5.406 11.0828 5.55435 11.0213 5.66372 10.9119L12.8568 3.71879C13.1002 3.48408 13.2791 3.19071 13.3764 2.86686C13.4736 2.54302 13.486 2.1996 13.4121 1.86963C13.3296 1.56274 13.168 1.28284 12.9436 1.05783C12.7191 0.832815 12.4397 0.670534 12.133 0.587153C11.8263 0.503772 11.5031 0.502202 11.1957 0.582599C10.8882 0.662996 10.6072 0.822554 10.3806 1.04538Z",
    fill: "#67686D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_19014_36039"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNomination);
export default __webpack_public_path__ + "static/media/nomination.f0d86681ff822a3d09a0d5e41b867bce.svg";
export { ForwardRef as ReactComponent };